<template >
    <div >
        <el-form   ref="lineForm" :model="tableData" label-width="110px" size="mini" >
<!--            <el-form-item prop="name" class="lable-width" label="用户名" :rules="{required: true, message: '请输入用户名', trigger: 'blur'}">-->
<!--                <el-input  class="input-width" placeholder="请输入用户名" clearable v-model="tableData.name" ></el-input>-->
<!--            </el-form-item>-->
            <!--            <el-form-item prop="phone" class="lable-width" label="手机号" :rules="{required: true, message: '请输入手机号', trigger: 'blur',pattern:/^1[3|5|7|8|9]\d{9}$/,message:'请输入正确的手机号'}">-->
            <el-form-item prop="uName" class="lable-width ceshi" label="用户" :rules="{required: true, message: '请选择用户', trigger: ['blur','change']}">
                <el-select ref="ruleSelect"  @change="nameChange" placeholder="请选择用户"  filterable remote :remote-method="namesearch" class="input-width " v-model="tableData.uName">
                    <el-option v-for="(val,index) in searchPeople" :key="index" :label="val.name+'('+val.phone+')'" :value="val.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  class="lable-width ceshi" label="余额" >
                <el-input   class="input-width"  disabled v-model="tableData.balance" ></el-input>

            </el-form-item>
<!--            <el-form-item  class="lable-width ceshi" label="近期充值时间" >-->
<!--                <el-input   class="input-width"  disabled v-model="tableData.finalTime" ></el-input>-->

<!--            </el-form-item>-->
            <el-form-item  class="lable-width" label="类型" :rules="{required: true, message: '请选择类型', trigger: 'change'}">
                <el-select  clearable  class="input-width"
                            value-key="appId"
                            v-model="tableData.type"
                            filterable
                            placeholder="请选择类型"
                >
                    <el-option
                            v-for="(item,index) in cztypedata"
                            :key="index"
                            :label="item.value"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item prop="moneyTotal" class="lable-width" label="金额(元)" :rules="{required: true, message: '请输入金额', trigger: ['change']}">
                <el-input @change="ceshic" oninput="value=value.replace(/[^0-9]/g,'')" class="input-width" placeholder="请输入金额" clearable v-model="tableData.moneyTotal" ></el-input>
            </el-form-item>
            <el-form-item prop="note" class="lable-width" :label="$t('form_notes')" >
                <el-input  class="input-width" placeholder="请填写备注" clearable v-model="tableData.wxContact" ></el-input>
            </el-form-item>

            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit('lineForm')" :disabled="savebtn">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'addBalance',
        props:{
            // editData:{
            //     type:Object
            // },
            // sqtypedata:{
            //     type:Array
            // }
        },
        data(){
            return{

                savebtn:false,
                tableData:{},
                searchPeople:[],
                cztypedata:[],
                search:'',
                userid:0,
                cztypedata:[{
                    id:2,
                    value:'现金'
                },{
                    id:3,
                    value:'转帐(微信/支付宝)'
                }],
            }
        },
        mounted(){
            this.selectWxUser()
            this.$set(this.tableData,'balance',0)
            this.$set(this.tableData,'finalTime','')

            // this.tableData=JSON.parse(JSON.stringify(this.editData))
            // if(this.tableData.wxContact==''){
            //     this.tableData.wxContact=this.tableData.phone
            // }
            //
            // if(this.tableData.appList.length>0){
            //     this.sqtypedata.map(item=>{
            //         this.tableData.appList.map(it=>{
            //             if(item.appId==it.appId){
            //                 item.id=it.id
            //             }
            //         })
            //     })
            // }

        },
        methods:{
            ceshic(e){
                this.tableData.moneyTotal=e
            },
            //延迟搜索
            namesearch(val){
                this.search=val
                    this.selectWxUser()
            },
            nameChange(val){
                this.search=val
                this.userid=val
                // this.formData.userId=val
                let newname=this.searchPeople.filter((item)=>{
                    return item.id==val
                })
                this.$set(this.tableData,'balance',newname[0].balance)
                this.$set(this.tableData,'finalTime',newname[0].finalTime)

                // console.log(newname)
                this.tableData.uName=newname[0].name
            },
            ...mapActions(["getCurrentMenuId"]),
            onSubmit(lineForm){
                this.$refs[lineForm].validate(valid=>{
                    if(valid){
                        // if(this.tableData.add==0){
                        //     this.addWxUser()
                        // }else{
                            if(!this.savebtn){
                                this.recharge()
                            }
                        // }
                    }
                })
            },
            close(){
                this.$emit('closedialog')
            },

            async selectWxUser() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
            uName:this.search
                }
                let res = await API.selectWxUser(params);
                if (res.code == 1) {
                this.searchPeople=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            async recharge() {
                this.savebtn=true
                if(this.userid==0){
                    this.$message.warning('请选择用户')
                    this.savebtn = false
                    return
                }
                if(!this.tableData.type){
                    this.$message.warning('请选择充值类型')
                    this.savebtn = false
                    return
                }


                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    uid:this.userid,
                    money:this.tableData.moneyTotal,
                    type:this.tableData.type,
                    note:!!this.tableData.wxContact?this.tableData.wxContact:''
                }

                let res = await API.recharge(params);
                if (res.code == 1) {
                    this.searchPeople=res.data
                    this.savebtn = false
                    this.$emit('savesuccess')
                    this.$message.success(res.message);

                } else if (res.code == -2) {
                    this.savebtn = false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.savebtn = false
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .upload-box img{
        width: 80px !important;
        height: 80px !important;
    }
    .lable-width{
        text-align: center;
    }
    .flexjcenter{
        display: flex;
        justify-content: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 15.571rem;
    }
    /*11111111111*/
    .mrr2{
        margin-right: 2px;
    }
    .img-box{
        /*border: 1px solid red;*/
        .uploadPhone{
            width: 70px;
            height: 80px;
            position: relative;
            width: 100px;
            padding-left: 50px;
            /*border: 1px solid cornflowerblue;*/
        }
        .uploadPhone .img{
            width: 80px;
            height: 80px;
            margin-right: 5px;
        }
        .elimg{
            width:105px
        }
        .el-icon-delete{
            padding-right: 5px;
        }


        .upload-box{
            /*background: red;*/
            width: 100%;
            height: 100%;
        }
        .upload-input{
            position: absolute;
            opacity: 0;
            width: 80px;
            height: 80px;
        }
    }
    .flex{
        display: flex;
    }
    .flex1{
        display: flex;
    }
    /*1111111111*/
    .input-width{
        width: 15.571rem;
    }
   /deep/.ceshi .el-select{
       .el-select__caret::before{
           content:"\e6e1"
       }
       .is-focus{
           .el-select__caret:first-child{
               transform:rotateZ(0deg);
           }
       }
   }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
    /deep/.el-form-item--mini.el-form-item,.el-form-item--small.el-form-item{
        margin-bottom:22px !important;
    }
</style>